import React from 'react'
import { createRoot } from 'react-dom/client'
import { HeroSection } from '../components/ui/HeroSection'
import { MotionProvider } from '../lib/motionProvider'

const mountLandingPage = () => {
  const rootEl = document.getElementById('landing-page-root')
  if (!rootEl) return

  if (rootEl.dataset.mounted === 'true') return
  rootEl.dataset.mounted = 'true'

  const root = createRoot(rootEl)
  root.render(
    <MotionProvider>
      <HeroSection />
    </MotionProvider>,
  )
}

document.addEventListener('turbo:load', mountLandingPage)
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountLandingPage)
} else {
  mountLandingPage()
}
